export const ROLES = {
  "Super Admin": 1,
  Admin: 2,
  Support: 3,
  "Claim Facilitator": 4,
  POS: 5,
  Doctor: 6,
  Investigator: 7,
};
